import React, { Component } from "react";
import PropTypes from "prop-types";
import { injectIntl, defineMessages } from "react-intl";
import axios from "axios";
import "./AdminLicenseConfig.css";
import { ReduxFormMaterialTextField } from "components";
import { AdminPageTitle, AdminPageTemplate } from "components";

class AdminLicenseConfig extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dragStatus: false,
      keyError: null,
      keyList: null,
      licenseKey: "",
      hostName: "",
      license: { file: null, error: null, list: null },
      template: { file: null, error: null, list: null },
      attachFile: { file: null, error: null, list: null },
    };
  }

  componentDidMount() {
    this.getSystemConfig();
  }

  getSystemConfig = async () => {
    const params = { category: "license" };
    try {
      const response = await axios.get("/exec/SystemConfig", { params });

      if (!response.data.error) {
        const result = response.data.list;
        var host = "";
        var key = "";
        result.map((item) => {
          if (item.parameter === "HostName") {
            host = item.value;
          } else if (item.parameter === "LicenseKey") {
            key = item.value;
          }
        });
        this.setState({
          hostName: host,
          licenseKey: key,
        });
      } else {
        this.setState({
          keyError: response.data.error[0].errInfo,
        });
      }
    } catch (err) {
      console.log(err);
    }
  };

  handleFile = (e, target) => {
    if (this.state.dragStatus) this.setState({ dragStatus: false });

    this.setState({ [target]: { file: e.target.files[0] } });
  };

  dragEnterHandler = (e) => {
    this.setState({ dragStatus: true });
  };

  dragLeaveHandler = () => {
    this.setState({ dragStatus: false });
  };

  //   resetFile = () => {
  //     this.setState({ file: null });
  //   };

  storeFile = async (target) => {
    this.setState({
      [target]: {
        ...this.state[target],
        error: null,
        list: null,
      },
    });

    const formData = new FormData();
    formData.append("file", this.state[target].file);

    const apiUrl =
      target === "license"
        ? "/api/v1/License/BuildLicense"
        : target === "template"
        ? "/api/v1/License/Template"
        : "/api/v1/License/Attach";
    try {
      const response = await axios.post(apiUrl, formData);

      if (!response.data.error) {
        const list = response.data.list;
        this.setState({
          [target]: {
            list: response.data.list,
          },
        });
      } else {
        this.setState({
          [target]: {
            error: response.data.error[0].errInfo,
          },
        });
      }
    } catch (err) {
      console.log(err);
    }

    this.setState({
      [target]: {
        ...this.state[target],
        file: null,
      },
    });
  };

  inputLicense = (e) => {
    this.setState({
      licenseKey: e.target.value,
    });
  };

  addLicense = async () => {
    this.setState({
      keyError: null,
      keyList: null,
    });

    const formData = new FormData();
    formData.append("licenseKey", this.state.licenseKey);
    formData.append("host", this.state.hostName);
    try {
      const response = await axios.post("/api/v1/License/LicenseKey", formData);

      if (!response.data.error) {
        this.setState({
          keyList: response.data.list,
        });
      } else {
        this.setState({
          keyError: response.data.error[0].errInfo,
        });
      }
    } catch (err) {
      console.log(err);
    }
  };

  inputHostname = (e) => {
    this.setState({
      hostName: e.target.value,
    });
  };

  getLicenseKey = async () => {
    this.setState({
      keyError: null,
      keyList: null,
      licenseKey: "",
    });

    const params = { host: this.state.hostName };
    try {
      const response = await axios.get("/api/v1/License/LicenseKey", {
        params,
      });

      if (!response.data.error) {
        this.setState({
          licenseKey: response.data.list,
        });
      } else {
        this.setState({
          keyError: response.data.error[0].errInfo,
        });
      }
    } catch (err) {
      console.log(err);
    }
  };

  render() {
    // 국제화 처리
    const { license, template, attachFile, keyError, keyList } = this.state;

    const { formatMessage } = this.props.intl;
    return (
      <div className="admin-license-config">
        <div className="group">
          <div className="group-title">라이센스</div>

          <div className="group-item">
            <div className="item-title">
              라이센스 파일 등록 (mudfix_license.enc)
            </div>
            <div className="set-file">
              <form>
                <div className="file-input">
                  {!!license.file ? (
                    <label>{license.file.name}</label>
                  ) : (
                    <label>
                      {defineMessages(
                        formatMessage({
                          id: "PhishingTemplateEditModal_25",
                          defaultMessage: "파일을 선택하세요.",
                        })
                      )}
                    </label>
                  )}
                  <input
                    accept="*"
                    type="file"
                    onDragEnter={this.dragEnterHandler}
                    onDragLeave={this.dragLeaveHandler}
                    onChange={(e) => this.handleFile(e, "license")}
                  />
                </div>
              </form>
              <div className="file-btns">
                <button
                  className={`default-button upload ${
                    !!license.file ? "" : "disable"
                  }`}
                  onClick={() => this.storeFile("license")}
                >
                  {defineMessages(
                    formatMessage({
                      id: "PhishingTemplateEditModal_26",
                      defaultMessage: "업로드",
                    })
                  )}
                </button>
              </div>
            </div>
            {!!license.error && (
              <div className="message red">{license.error}</div>
            )}
            {!!license.list && <div className="message green">Success</div>}
          </div>

          <div className="group-item">
            <div className="item-title">라이센스 키 등록</div>
            <div className="set-text">
              <input
                className="input-text"
                type="text"
                onChange={this.inputHostname}
                placeholder="Hostname"
                value={this.state.hostName}
              />
              <button className="default-button" onClick={this.getLicenseKey}>
                가져오기
              </button>
            </div>
            <div className="set-text">
              <input
                className="input-text"
                type="text"
                onChange={this.inputLicense}
                placeholder="License Key"
                value={this.state.licenseKey}
              />
              <button className="default-button" onClick={this.addLicense}>
                등록
              </button>
            </div>
            {!!keyError && <div className="message red">{keyError}</div>}
            {!!keyList && <div className="message green">Success</div>}
          </div>
        </div>

        <div className="group">
          <div className="group-title">템플릿</div>
          <div className="group-item">
            <div className="item-title">템플릿 파일 등록</div>
            <div className="set-file">
              <form>
                <div className="file-input">
                  {!!template.file ? (
                    <label>{template.file.name}</label>
                  ) : (
                    <label>
                      {defineMessages(
                        formatMessage({
                          id: "PhishingTemplateEditModal_25",
                          defaultMessage: "파일을 선택하세요.",
                        })
                      )}
                    </label>
                  )}
                  <input
                    accept="*"
                    type="file"
                    onDragEnter={this.dragEnterHandler}
                    onDragLeave={this.dragLeaveHandler}
                    onChange={(e) => this.handleFile(e, "template")}
                  />
                </div>
              </form>
              <div className="file-btns">
                <button
                  className={`default-button upload ${
                    !!template.file ? "" : "disable"
                  }`}
                  onClick={() => this.storeFile("template")}
                >
                  {defineMessages(
                    formatMessage({
                      id: "PhishingTemplateEditModal_26",
                      defaultMessage: "업로드",
                    })
                  )}
                </button>
              </div>
            </div>
            {!!template.error && (
              <div className="message red">{template.error}</div>
            )}
            {!!template.list && <div className="message green">Success</div>}
          </div>
        </div>

        <div className="group">
          <div className="group-title">첨부 파일</div>
          <div className="group-item">
            <div className="item-title">첨부 파일 등록</div>
            <div className="set-file">
              <form>
                <div className="file-input">
                  {!!attachFile.file ? (
                    <label>{attachFile.file.name}</label>
                  ) : (
                    <label>
                      {defineMessages(
                        formatMessage({
                          id: "PhishingTemplateEditModal_25",
                          defaultMessage: "파일을 선택하세요.",
                        })
                      )}
                    </label>
                  )}
                  <input
                    accept="*"
                    type="file"
                    onDragEnter={this.dragEnterHandler}
                    onDragLeave={this.dragLeaveHandler}
                    onChange={(e) => this.handleFile(e, "attachFile")}
                  />
                </div>
              </form>
              <div className="file-btns">
                <button
                  className={`default-button upload ${
                    !!attachFile.file ? "" : "disable"
                  }`}
                  onClick={() => this.storeFile("attachFile")}
                >
                  {defineMessages(
                    formatMessage({
                      id: "PhishingTemplateEditModal_26",
                      defaultMessage: "업로드",
                    })
                  )}
                </button>
              </div>
            </div>
            {!!attachFile.error && (
              <div className="message red">{attachFile.error}</div>
            )}
            {!!attachFile.list && <div className="message green">Success</div>}
          </div>
        </div>
      </div>
    );
  }
}

AdminLicenseConfig.propTypes = {};
AdminLicenseConfig.defaultProps = {};

export default injectIntl(AdminLicenseConfig);



// WEBPACK FOOTER //
// ./src/script/components/admin/license/AdminLicenseConfig.js